import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { setField } from '../../state/slice/form'

export default function ApplicationClaimKey () {
  const [params] = useSearchParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (params.get('claimKey')) {
      dispatch(setField('context.claimKey.value', params.get('claimKey')))
    }
    navigate('/home')
  }, [params, dispatch, navigate])

  return <></>
}